import { render, staticRenderFns } from "./dashboardDetails.vue?vue&type=template&id=a6b0add6&scoped=true&"
import script from "./dashboardDetails.vue?vue&type=script&lang=js&"
export * from "./dashboardDetails.vue?vue&type=script&lang=js&"
import style0 from "./dashboardDetails.vue?vue&type=style&index=0&id=a6b0add6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b0add6",
  null
  
)

export default component.exports